module.exports = __webpack_public_path__ + "img/wrong.f372addb.png";